import * as React from 'react'
import { Content } from '../../atoms/Content/index'
import { Layout } from '../../atoms/Layout'
import { Nav } from '../../atoms/Nav'
import { ProfileDropdown } from '../../organisms/ProfileDropdown'
import {KidsGamesView} from '../../organisms/KidsGame/KidsGameView'
import MenuStore from "../../stores/MenuStore";
import MobileMenu from "../../atoms/MobileMenu";
import {KidsPageCheck} from "../../atoms/KidsPageCheck";
import {withRouter} from "react-router";
import {Query} from '@apollo/client/react/components'
import {GET_OWN_INTAKE_QUERY} from "../../queries/GET_OWN_INTAKE_QUERY";
import {intakeMetrics} from "../../organisms/Intakes/intakeMetrics/calcIntakeMetrics";

const lang = process.env.REACT_APP_LANGUAGE === 'es' ? 'es' : 'en'

const translations = {
  'en': {
    activities: 'Activities',
    games: 'Games',
    tour: 'Tour',
    video: 'Video',
  },
  'es': {
    activities: 'Actividades',
    games: 'Juegos',
    tour: 'Recorrido',
    video: 'Video',
  },
}
export class SleepGame extends React.Component {
  menuStore

  constructor (props) {
    super(props)
    this.menuStore = MenuStore.create({})
  }

  render() {
    return (
      <Layout hasKidBackground>
        <Nav.KidsBar>
          <Nav.KidsSite
            onClick={() => {
              this.menuStore.showMenu()
            }}
          />
          <Nav.KidsButton link="/kids-video" name="navBarVideo" text={`${translations[lang].video}`} />
          <Nav.KidsButton link="/kids-tour" name="navBarTourActive" text={`${translations[lang].tour}`} />
          <Nav.KidsButton link="/kids-games" name="navBarGames" active text={`${translations[lang].games}`} />
          <Nav.KidsButton link="/kids-activities" name="navBarActivities" text={`${translations[lang].activities}`} />
          <ProfileDropdown color="#CEE3F9"/>
        </Nav.KidsBar>
        <MobileMenu store={this.menuStore} />
        <Content>
          <KidsGamesView selectedGameVideo={'sleepGameVideo'} title={process.env.REACT_APP_LANGUAGE === 'es' ?
            'Juego del Cuarto de Dormir' : 'Sleep room game'}/>
        </Content>
      </Layout>
    )
  }
}

const KidsSleepGame = withRouter(
  class Page extends React.Component {
    render () {
      return (
        <Query query={GET_OWN_INTAKE_QUERY}>{({ data, loading, error }) => {
          if (loading) { return null }
          if (error || !data || !data.getOwnIntake) { window.location.reload() }
          const intake = data.getOwnIntake
          const {
            section4ReviewCompleted
          } = intakeMetrics(intake)

          if (!section4ReviewCompleted) {
            this.props.history.replace('/kids-forbidden')
            return <div />
          }

          return (
            <SleepGame />
          )
        }}
        </Query>
      )
    }
  }
)

export {KidsSleepGame}



// WEBPACK FOOTER //
// ./src/pages/KidsSleepGame/index.js